import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import premiumSubscriptionAPI from '../../sources/api/premiumSubscriptionAPI';

// constants
import { PAYMENT_API_RESPONSE_SEND } from '../../constants/premiumSubscriptionTypes';

// lib
import httpSaga from '../../lib/httpSaga';
import { tooltipEdit } from '../../actions/tooltipActions';
import ReactGA from 'react-ga';

// schemas

function* GAPaymentConversionEvent() {
  yield ReactGA.event({
    category: 'Conversion',
    action: 'Trial purchase',
    label: 'Payment conversion'
  });
}

export function* paymentApiRespondSend(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    const response = yield *httpSaga(PAYMENT_API_RESPONSE_SEND, call(premiumSubscriptionAPI.respondSend, params));
    //todo: only if trial
    yield GAPaymentConversionEvent();

    yield put(tooltipEdit({ id: 'charging-modal', status: 'success' }));
  } catch (e) {
    yield put(tooltipEdit({ id: 'charging-modal', status: 'error' }));
    yield put(error(PAYMENT_API_RESPONSE_SEND, e));
  } finally {
    yield put(doneIndicator(PAYMENT_API_RESPONSE_SEND));
  }
}

export function* watchPaymentApiRespondSend() {
  yield takeEvery(PAYMENT_API_RESPONSE_SEND, paymentApiRespondSend);
}

export default function* root() {
  yield all([
    fork(watchPaymentApiRespondSend)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/premium/paymentApiResponseSend.js